export default __webpack_public_path__ + "static/media/footer_image.1a99f0c1.png";